<template>
  <v-card-text>
    <v-select
            :items="relatedSchemas"
            :label="`${$t('related.related_schema')}`"
            item-text="name"
            item-value="id"
            required
            @change="update({relatedId: $event})"
    >
    </v-select>
    <v-switch
      :label="`${$t('schema.builder.inputs.options.required')}`"
      :input-value="options.required"
      @change="update({required: $event})"
    ></v-switch>
    <v-switch
      :label="`${$t('schema.builder.inputs.options.scan-only')}`"
      :input-value="options.scanOnly"
      @change="update({scanOnly: $event})"
    ></v-switch>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "date-options",
  computed: {
      relatedSchemas() {
          return this.$store.state.relatedSchemas
      }
  },
  mixins: [ options ],
  methods: {
    loadRelatedSchemas(){
    if(this.relatedSchemas.length == 0)
        return this.$store.dispatch('loadRelatedSchemas')
    }
  },
  created(){
    this.loadRelatedSchemas()
  }
}
</script>
<style>
</style>
